import { motion } from "framer-motion";

const RINGS = [
  { r: 148, dash: "1 14", sw: 1.5, dur: 70, op: 0.9 },
  { r: 120, dash: "26 12", sw: 2, dur: 55, rev: true, op: 0.5 },
  { r: 92, dash: "2 8", sw: 1.5, dur: 42, op: 0.8 },
  { r: 64, dash: "14 10", sw: 2, dur: 32, rev: true, op: 0.5 },
  { r: 40, dash: "1 6", sw: 1.5, dur: 24, op: 0.9 },
];

export default function SignalRings({ className = "" }) {
  return (
    <div className={className} data-testid="signal-rings">
      <svg viewBox="0 0 320 320" className="h-full w-full">
        {RINGS.map((ring, i) => (
          <motion.g
            key={i}
            style={{ transformBox: "fill-box", transformOrigin: "center" }}
            animate={{ rotate: ring.rev ? -360 : 360 }}
            transition={{ repeat: Infinity, duration: ring.dur, ease: "linear" }}
          >
            <circle
              cx="160"
              cy="160"
              r={ring.r}
              fill="none"
              stroke="#FF3D8A"
              strokeWidth={ring.sw}
              strokeDasharray={ring.dash}
              strokeLinecap="round"
              opacity={ring.op}
            />
          </motion.g>
        ))}
        <motion.circle
          cx="160"
          cy="160"
          r="5"
          fill="#2F6BFF"
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          animate={{ scale: [1, 1.9, 1], opacity: [1, 0.35, 1] }}
          transition={{ repeat: Infinity, duration: 2.4, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
}
